<template>
<div>
  <b-form-group class="mb-2">
    <vue-typeahead-bootstrap
      class="search-input"
      :data="addresses"
      v-model="value.name"
      :serializer="s => s.name"
      :placeholder="$t('Enter a hotel name or destination')"
      @input="addressSearch"
      @hit="selecteduser"
      ref="typeahead"
    >
    <template slot="prepend">
      <span class="input-group-text bg-white">
        <b-icon icon="search"></b-icon>
      </span>
    </template>
    <template slot="suggestion" slot-scope="{ data, htmlText }">
        <div class="d-flex align-items-center">
          <font-awesome-icon v-if="data.type == 'tourist_attraction'" :icon="['fas', 'university']" size="lg" />
          <font-awesome-icon v-else-if="data.type == 'locality'" :icon="['fas', 'city']" size="lg" />
          <font-awesome-icon v-else-if="data.type == 'premise'" :icon="['fas', 'university']" size="lg" />
          <font-awesome-icon v-else-if="data.type == 'natural_feature'" :icon="['fas', 'tree']" size="lg" />
          <font-awesome-icon v-else-if="data.type == 'park'" :icon="['fas', 'tree']" size="lg" />
          <font-awesome-icon v-else-if="data.type == 'train_station'" :icon="['fas', 'train']" size="lg" />
          <font-awesome-icon v-else-if="data.type == 'subway_station'" :icon="['fas', 'subway']" size="lg" />
          <font-awesome-icon v-else-if="data.type == 'bus_station'" :icon="['fas', 'bus']" size="lg" />
          <font-awesome-icon v-else-if="data.type == 'lodging'" :icon="['fas', 'hotel']" size="lg" />
          <font-awesome-icon v-else-if="data.type == 'airport'" :icon="['fas', 'plane']" size="lg" />
          <font-awesome-icon v-else :icon="['fas', 'map-marker-alt']" size="lg" />
          <span class="ml-3" v-html="htmlText"></span>
        </div>
      </template>
    </vue-typeahead-bootstrap>
  </b-form-group>
</div>
</template>

<script>
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import _ from 'underscore'

import { library } from '@fortawesome/fontawesome-svg-core'
import { 
  faMapMarkerAlt,
  faUniversity,
  faHotel,
  faPlane,
  faTree,
  faTrain,
  faSubway,
  faBus,
  faCity,
} from '@fortawesome/free-solid-svg-icons'

library.add(faMapMarkerAlt)
library.add(faUniversity)
library.add(faHotel)
library.add(faPlane)
library.add(faTree)
library.add(faTrain)
library.add(faSubway)
library.add(faBus)
library.add(faCity)
 
const API_URL = 'https://api.stay.com.de/?action=location-search&search=:query&key=380d67badb15b85f636a0eb3957373f2'
 
export default {
    name: 'LocationSearch',
    components: {
        VueTypeaheadBootstrap,
    },
    props: {
        value: {
            type: Object,
            required: true
        }
    },
 
  data() {
    return {
      addresses: [],
      selectedAddress: null
    }
  },
 
  methods: {
    async getAddresses(query) {
      const res = await fetch(API_URL.replace(':query', query))
      const suggestions = await res.json()
      this.addresses = suggestions;
    },
    addressSearch: _.debounce(function(addr) { this.getAddresses(addr) }, 500),
    selecteduser: function(item) {
        this.value.name = item.name;
        this.value.lat = item.lat;
        this.value.lng = item.lng;
        this.$emit('input', this.value )
      }
  }
}
</script>

<style>
  @media screen and (min-width:991px) {
    .search-input .form-control {
      border-radius:0;
    }
  }
</style>

<style>
.search-input .list-group:after{
  content: "";
  background-image:url('~@/assets/powered_by_google_on_white.png');
  background-color: #fff;
  font-size: 0.6rem;
  border-radius: 0 0 5px 5px;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  text-align: right;
  background-repeat: no-repeat;
  background-position: calc(100% - 5px) calc(50% + 2px);
  background-size: 100px auto;
  padding: 10px 0 15px 0;
  margin-top: -3px;
}
</style>